import React, { useMemo, useState } from 'react';
import Grid from '../../Grid';

const WORD_LENGTH = 5;

const normalizeGuess = (guess) => String(guess || '').trim().toUpperCase();

const AnsweredGridPreview = ({ guesses = [], solution = '' }) => {
  const [showGuesses, setShowGuesses] = useState(false);
  const answeredGuesses = useMemo(
    () =>
      (Array.isArray(guesses) ? guesses : [])
      .map((guess) => normalizeGuess(guess))
      .filter((guess) => guess.length === WORD_LENGTH),
    [guesses]
  );

  if (!solution || answeredGuesses.length === 0) return null;

  return (
    <div className="result-answer-grid" aria-label="Answered grid">
      {showGuesses && (
        <div className="result-answer-grid__board">
          <Grid
            guesses={answeredGuesses}
            currentGuess=""
            currentRow={answeredGuesses.length}
            solution={solution}
            isTypingEnabled={false}
          />
        </div>
      )}
      <button
        type="button"
        className="definition-button result-answer-grid__toggle"
        onClick={() => setShowGuesses((prev) => !prev)}
        aria-expanded={showGuesses}
      >
        {showGuesses ? 'Hide Guesses' : 'Show Guesses'}
      </button>
    </div>
  );
};

export default AnsweredGridPreview;
